import React from 'react';
import './Certificates.css';

const Certificates = () => {
  const certificates = [
    {
      id: 1,
      title: "ISO 9001 & 14001",
      image: "/img/certificates/iso9001.jpeg",
     
    },
    {
      id: 2,
      title: "WASH",
      image: "/img/certificates/iso14001.jpeg",
      
    },
    {
      id: 3,
      title: "bizSAFE",
      image: "/img/certificates/iso45001.png",
      
    }
  ];

  return (
    <>
      <div className="page-header">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2>Our Certificates</h2>
            </div>
          </div>
        </div>
      </div>

      <div className="certificates wow fadeInUp" data-wow-delay="0.1s">
        <div className="container">
          <div className="section-header text-center">
            {/* <p>Our Certifications</p>
            <h2>Quality Certifications & Standards</h2> */}
          </div>
          <div className="row">
            {certificates.map((cert) => (
              <div key={cert.id} className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.2s">
                <div className="certificate-item">
                  <div className="certificate-title">
                    <h3>{cert.title}</h3>
                  </div>
                  <div className="certificate-img">
                    <a href={cert.image} data-lightbox="certificate">
                      <img src={cert.image} alt={cert.title} />
                    </a>
                  </div>
                  <div className="certificate-text">
                    {/* <p>{cert.description}</p> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Certificates;